// FastAPI validation errors (422) return `detail` as an array of objects
// ({type, loc, msg, input, url}), not a string — rendering that directly in
// JSX crashes React ("Objects are not valid as a React child"). This safely
// turns any `err.response.data.detail` shape into a plain string.
export function getErrorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    return detail.map((d) => (typeof d === 'string' ? d : d?.msg)).filter(Boolean).join(' ') || fallback;
  }
  if (detail && typeof detail === 'object' && detail.msg) return detail.msg;
  return fallback;
}
